import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Typography,
} from '@mui/material'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { hideSendToApproveDialog } from '../../store/slice/dialogSlice'
import { usePostVendorSendToApproveMutation } from '../../store/api/vendorApi'
import { usePostRequestSendToApproveMutation } from '../../store/api/requestApi'
import { offRefreshButton, onRefreshButton } from '../../store/slice/buttonSlice'
import { showErrorToast, showSuccessToast, showWarningToast } from '../../constToast/constToast'
import { usePostOrderSendToApproveMutation } from '../../store/api/orderApi'
import { usePostSendToApproveComparisonMutation } from '../../store/api/bidComparsion'

import { updatePaymentTabIndex } from '../../store/slice/tabIndexSlice'
import { usePostApproveInvoiceRegisterMutation } from '../../store/api/invoiceApi'
import { updateRefetchData } from '../../store/slice/otherSlice'

const SendToApproveDialog = ({ ids, callback }) => {
  const dispatch = useDispatch()
  const handleClose = () => {
    dispatch(hideSendToApproveDialog())
  }
  const open = useSelector((state) => state.dialogSlice.sendToApproveDialog)
  const url = useLocation().pathname
  const { dataId } = useParams()
  const navigate = useNavigate()

  const vendorData = useSelector((state) => state.mainToCard.vendorData)
  const orderData = useSelector((state) => state.mainToCard.orderData)
  const requestDataSlice = useSelector((state) => state.persistSlice.requestData)
  const paymentDataSlice = useSelector((state) => state.persistSlice.paymentData)
  const selectedBidComparsionGridData = useSelector((state) => state.bidComparsionSlice.selectedGridData)
  const paymentCardDataSlice = useSelector((state) => state.paymentSlice.paymentCardDataSlice)
  const paymentCardDataSliceHeader = paymentCardDataSlice?.header
  const invoiceMain = useSelector((state) => state.mainToCard.invoiceMain)


  const [postVendorSendToApprove] = usePostVendorSendToApproveMutation()
  const [postRequestSendToApprove] = usePostRequestSendToApproveMutation()
  const [postOrderSendToApprove] = usePostOrderSendToApproveMutation()
  const [postBidComparisonApprove] = usePostSendToApproveComparisonMutation()
  const [postRegisterInvoiceApprove] = usePostApproveInvoiceRegisterMutation()

  let content, action, name

  const handleRefresh = () => {
    dispatch(onRefreshButton())
    setTimeout(() => {
      dispatch(offRefreshButton(false))
    }, 1)
  }

  const handlePostOrder = async () => {
    if (orderData?.length > 10) {
      showWarningToast('Data is more than 10.')
    } else {
      const data = await postOrderSendToApprove(orderData?.map((x) => String(x.orderMainId)))
      handleRefresh();
      handleClose()
      if (data?.data?.statusCode === 200) {
        showSuccessToast('Succesfully')
      } else {
        showWarningToast(`Error with currency rate in following order(s): ${data?.error?.data?.errors}. Please contact with Commercial Department.`)
      }
      dispatch(updateRefetchData())
    }
  }

  switch (url) {
    // Vendors
    case '/vendors':
      name = <>{vendorData[0] ? vendorData[0]?.vendorName : ''}</>
      content = (
        <>
          <Typography component="span">
            Are you sure, you want to send to approve {vendorData[0]?.vendorName} ?
          </Typography>
        </>
      )
      action = (
        <Button
          variant="contained"
          onClick={() => {
            const data = postVendorSendToApprove({
              vendorIds: [vendorData[0]?.vendorId],
            })
            dispatch(updateRefetchData())
            handleClose()
            if (data?.data?.statusCode === 200) {
              showSuccessToast('Succesfully')
            }
          }}
        >
          Send To Approve
        </Button>
      )
      break

    // requests
    case '/requests':
      name = <>{requestDataSlice && requestDataSlice?.map((item) => item.requestNo).join(', ')}</>
      content = (
        <>
          <Typography component="span">
            Are you sure, you want to send to approve{' '}
            {requestDataSlice && requestDataSlice?.map((item) => item.requestNo).join(', ')}?
          </Typography>
        </>
      )
      action = (
        <Button
          variant="contained"
          onClick={async () => {
            const data = await postRequestSendToApprove({
              requestMainIds: requestDataSlice && requestDataSlice?.map((item) => item.requestMainId),
            })
            handleRefresh()
            handleClose()
            if (data?.data?.statusCode === 200) {
              showSuccessToast('Succesfully')
            }
          }}
        >
          Send To Approve
        </Button>
      )
      break


 
    // Orders
    case '/orders':
      name = <>{orderData[0] ? orderData?.map((x) => x.orderNo).join(', ') : ''}</>
      content = (
        <>
          <Typography component="span">
            Are you sure, you want to send to approve {orderData?.map((x) => x.orderNo).join(', ')} ?
          </Typography>
        </>
      )
      action = (
        <Button
          variant="contained"
          onClick={handlePostOrder}
        >
          Send To Approve
        </Button>
      )
      break
    case `/bid-comparison/${selectedBidComparsionGridData[0]?.rfqMainId}`:
      name = (
        <>
          {selectedBidComparsionGridData[0]
            ? selectedBidComparsionGridData[0]?.rfqNumber || selectedBidComparsionGridData[0]?.rfqNo
            : ''}
        </>
      )
      content = (
        <>
          <Typography component="span">
            Are you sure, you want to send to approve{' '}
            {selectedBidComparsionGridData[0]?.rfqNumber || selectedBidComparsionGridData[0]?.rfqNo} ?
          </Typography>
        </>
      )
      action = (
        <Button
          variant="contained"
          onClick={async () => {
            const data = await postBidComparisonApprove({
              bidComparisonId: selectedBidComparsionGridData[0]?.bidComparisonId,
            })
            handleRefresh()
            handleClose()
            if (data?.data?.statusCode === 200) {
              showSuccessToast('Successfully')
              navigate('/bid-comparison')
            }
          }}
        >
          Send To Approve
        </Button>
      )
      break
    case '/invoice-register':
      content = (
        <>
          {invoiceMain[0] ? (
            <Typography component="span">
              Are you sure, you want to send to approve{' '}
              <span style={{ fontWeight: 'bold', color: 'black' }}>
                Invoice No: {invoiceMain[0].invoiceNo}
              </span>
              {' ?'}
            </Typography>
          ) : (
            <Typography component="span">Invoice not found</Typography>
          )}
        </>
      )
      action = invoiceMain[0] ? (
        <Button
          variant="contained"
          onClick={async () => {
            handleClose()
            handleRefresh()
            handleRefresh()
            const data = await postRegisterInvoiceApprove({ invoiceRegisterIds: [invoiceMain[0]?.invoiceRegisterId] })
            if (data?.data?.statusCode === 200) {
              showSuccessToast(`${invoiceMain[0]?.invoiceNo} sent for approval`)
            } else {
              showErrorToast('Error')
            }
          }}
        >
          Send To Approve
        </Button >
      ) : (
        <></>
      )
      break
    default:
      content = null
      break
  }

  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle>Send to Approve {name}</DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText>{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          {action}
          <Button variant="outlined" onClick={handleClose} sx={{ color: 'gray', borderColor: '#D3D3D3' }}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default SendToApproveDialog